import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { WarehousesService } from '../../../services/warehouses.service';

export interface WarehouseSelection {
  id: number;
  nome: string;
  responsavel: string;
  localizacao: string;
  telefone: string;
  email: string;
}

@Component({
  selector: 'app-warehouse-selection-modal',
  templateUrl: './warehouse-selection-modal.component.html',
  styleUrls: ['./warehouse-selection-modal.component.css']
})
export class WarehouseSelectionModalComponent implements OnInit {
  @Output() warehouseSelected = new EventEmitter<WarehouseSelection>();
  @Output() closeModal = new EventEmitter<void>();

  showModal: boolean = false;
  searchTerm: string = '';
  warehouses: WarehouseSelection[] = [];
  filteredWarehouses: WarehouseSelection[] = [];
  selectedWarehouse: WarehouseSelection | null = null;
  loading: boolean = false;

  constructor(private warehousesService: WarehousesService) {}

  ngOnInit(): void {
    this.loadWarehouses();
  }

  /**
   * Carrega almoxarifados reais da API.
   */
  loadWarehouses(): void {
    this.loading = true;
    this.warehousesService.getAll({ page: 1, pageSize: 50 }).subscribe({
      next: (result) => {
        const items = result.items || [];
        this.warehouses = items.map((w) => ({
          id: w.id,
          nome: w.name || '',
          responsavel: w.responsiblePerson || w.managerStaffName || '',
          localizacao: [w.address, w.city, w.state].filter(Boolean).join(', '),
          telefone: w.responsiblePhone || '',
          email: w.responsibleEmail || ''
        }));
        this.filteredWarehouses = [...this.warehouses];
        this.loading = false;
      },
      error: (err) => {
        console.error('Erro ao carregar almoxarifados:', err);
        this.warehouses = [];
        this.filteredWarehouses = [];
        this.loading = false;
      }
    });
  }

  /**
   * @deprecated Mantido para compatibilidade — não é mais utilizado.
   */
  loadMockWarehouses(): void {
    this.warehouses = [
      {
        id: 1,
        nome: 'Almoxarifado Central',
        responsavel: 'João Silva',
        localizacao: 'Galpão A - Setor 1',
        telefone: '(11) 98765-4321',
        email: 'almoxarifado.central@empresa.com'
      },
      {
        id: 2,
        nome: 'Almoxarifado Peças',
        responsavel: 'Maria Santos',
        localizacao: 'Galpão B - Setor 2',
        telefone: '(11) 91234-5678',
        email: 'almoxarifado.pecas@empresa.com'
      },
      {
        id: 3,
        nome: 'Almoxarifado Ferramentas',
        responsavel: 'Pedro Oliveira',
        localizacao: 'Galpão C - Setor 3',
        telefone: '(11) 99876-5432',
        email: 'almoxarifado.ferramentas@empresa.com'
      },
      {
        id: 4,
        nome: 'Almoxarifado Químicos',
        responsavel: 'Ana Costa',
        localizacao: 'Galpão D - Setor 4',
        telefone: '(11) 97654-3210',
        email: 'almoxarifado.quimicos@empresa.com'
      },
      {
        id: 5,
        nome: 'Almoxarifado Emergência',
        responsavel: 'Carlos Mendes',
        localizacao: 'Galpão E - Setor 5',
        telefone: '(11) 96543-2109',
        email: 'almoxarifado.emergencia@empresa.com'
      },
      {
        id: 6,
        nome: 'Almoxarifado Regional',
        responsavel: 'Roberto Lima',
        localizacao: 'Filial SP - Centro',
        telefone: '(11) 95432-1098',
        email: 'almoxarifado.regional@empresa.com'
      }
    ];
    this.filteredWarehouses = [...this.warehouses];
  }

  open(): void {
    this.showModal = true;
    this.searchTerm = '';
    this.selectedWarehouse = null;
    this.filteredWarehouses = [...this.warehouses];
  }

  close(): void {
    this.showModal = false;
    this.closeModal.emit();
  }

  onSearch(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredWarehouses = this.warehouses.filter(warehouse =>
      warehouse.nome.toLowerCase().includes(term) ||
      warehouse.responsavel.toLowerCase().includes(term) ||
      warehouse.localizacao.toLowerCase().includes(term) ||
      warehouse.telefone.includes(term) ||
      warehouse.email.toLowerCase().includes(term)
    );
  }

  selectWarehouse(warehouse: WarehouseSelection): void {
    this.selectedWarehouse = warehouse;
  }

  confirmSelection(): void {
    if (this.selectedWarehouse) {
      this.warehouseSelected.emit(this.selectedWarehouse);
      this.close();
    }
  }
}
